var _style, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPositiveLabResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D70000;}\r\n\t.st1{fill:#009245;}\r\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st3{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st10{fill:#004B87;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st12{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 15,
    cy: 15,
    r: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M17.359,6.11h-4.717c-0.423,0-0.767,0.343-0.767,0.767c0,0.423,0.343,0.767,0.767,0.767h0.124l0,14.014 c0,1.124,0.758,2.165,1.864,2.365c1.453,0.262,2.718-0.847,2.718-2.253V7.643h0.011c0.423,0,0.767-0.343,0.767-0.767 C18.125,6.453,17.782,6.11,17.359,6.11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M15,24.061L15,24.061c1.265,0,2.291-1.026,2.291-2.291v-6.502h-4.582v6.502 C12.709,23.035,13.735,24.061,15,24.061z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPositiveLabResult);
export default __webpack_public_path__ + "static/media/icon_positive_lab_result.68b615fa445562cd9c1320456b5d0c0f.svg";
export { ForwardRef as ReactComponent };